/* iArena: WhatsApp / Viber "ask about this product" buttons (product page) */
(function () {
  function init(box) {
    var digits = box.getAttribute('data-digits');
    var msg = box.getAttribute('data-msg');
    var title = box.getAttribute('data-title');
    var url = box.getAttribute('data-url');
    var variants = {};
    try { variants = JSON.parse((box.querySelector('[data-ar-variants]') || {}).textContent || '{}'); } catch (e) {}
    var form = box.closest('.product_section, .product-form-container, form') || document;
    function selectedVariant() {
      var el = document.querySelector('form[action*="/cart/add"] [name="id"]:checked, form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"]');
      if (el && el.value && variants[el.value]) return { id: el.value, v: variants[el.value] };
      var m = location.search.match(/variant=(\d+)/);
      if (m && variants[m[1]]) return { id: m[1], v: variants[m[1]] };
      return null;
    }
    function text() {
      var sel = selectedVariant();
      var s = msg + ' ' + title;
      var link = url;
      if (sel) {
        if (sel.v.t && sel.v.t !== 'Default Title') s += ', размер ' + sel.v.t;
        s += ' — ' + sel.v.p;
        link += '?variant=' + sel.id;
      }
      return s + '\n' + link;
    }
    function copy(t) {
      try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t); } catch (e) {}
    }
    function toast() {
      var el = box.querySelector('.ar-chat__toast');
      if (!el) return;
      el.hidden = false;
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.hidden = true; }, 6000);
    }
    box.querySelectorAll('[data-ar-chat]').forEach(function (a) {
      a.addEventListener('click', function () {
        var t = text();
        if (a.getAttribute('data-ar-chat') === 'wa') {
          a.href = 'https://wa.me/' + digits + '?text=' + encodeURIComponent(t);
        } else {
          a.href = 'viber://chat?number=' + encodeURIComponent('+' + digits) + '&text=' + encodeURIComponent(t);
          copy(t);
          toast();
        }
        if (window.gtag) { try { gtag('event', 'contact_click', { method: a.getAttribute('data-ar-chat') === 'wa' ? 'whatsapp' : 'viber', item_name: title }); } catch (e) {} }
      });
    });
  }
  function run() { document.querySelectorAll('.ar-chat').forEach(function (b) { if (!b._arChat) { b._arChat = 1; init(b); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
